import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {ProductParameterFormatImage} from './model';

export interface ProductParameterFormatImageState extends EntityState<ProductParameterFormatImage> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ProductParameterFormatImage' })
export class Store extends EntityStore<ProductParameterFormatImageState> {

  constructor() {
    super();
  }

}
